import React from 'react'

import { Typography } from '@mui/material'

import { SingleNumberLoader } from './SingleNumberLoader'
import { formatNumber } from '@edge/spark/utils'

import type { CardType } from '@edge/spark/io-dashboards'
import { WidgetContainer } from '../../WidgetContainer'

interface Props {
    cardType: CardType
    action?: {
        text: string
        link: string
    }
    number?: number | string | null
    secondaryText?: string | React.ReactNode
    text: string
    text2?: string
    text3?: string
    loading: boolean
    loaderWidth?: number
    widgetId: string
    handleConfig?: (widgetId: string) => void
    readonly: boolean
    handleDisplayDetails?: (widgetId: string) => void
    cardHeaderText?: string
}

export const SingleNumberWidget: React.FC<Props> = ({
    cardType,
    action,
    number,
    text,
    text2,
    text3,
    secondaryText,
    loading,
    loaderWidth = 80,
    widgetId,
    handleConfig,
    readonly,
    handleDisplayDetails,
    cardHeaderText,
}: Props) => {
    const value = formatNumber(number) || '--'
    const missingValue = value === '--' || !value

    return (
        <WidgetContainer
            loading={loading}
            cardType={cardType}
            cardHeaderText={cardHeaderText}
            action={action}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
            handleDisplayDetails={handleDisplayDetails}
        >
            <SingleNumberLoader loading={loading && missingValue} width={loaderWidth}>
                <Typography sx={{ mt: 1 }} variant="h5" align="left">
                    {value}
                </Typography>
            </SingleNumberLoader>
            <Typography variant="subtitle2" align="left">
                {text}
            </Typography>
            {text2 && (
                <Typography variant="subtitle2" align="left">
                    {text2}
                </Typography>
            )}
            {text3 && (
                <Typography variant="subtitle2" align="left">
                    {text3}
                </Typography>
            )}
            <Typography variant="caption" align="left">
                {secondaryText}
            </Typography>
        </WidgetContainer>
    )
}
